import imageSVG_1 from "../../../../src/content/demographics/google_Desktop9.svg";
import imageSVG_2 from "../../../../src/content/demographics/google_Desktop10.svg";
import imageSVG_3 from "../../../../src/content/demographics/google_Desktop11.svg";
import imageSVG_4 from "../../../../src/content/demographics/google_Desktop12.svg";
import * as React from 'react';
export default {
  imageSVG_1,
  imageSVG_2,
  imageSVG_3,
  imageSVG_4,
  React
};